<div>
  @if (showTeamAssignationModal) {
<app-team-assignation-modal
    [people]="selectedPersonForAssignation"
    [contextTeamId]="contextTeamIdForAssignation"
    (modalClosed)="handleTeamAssignationUpdate($event)">
  </app-team-assignation-modal>
}

  @if (showSelectManagerModal) {
<app-select-people-modal
    [showModal]="showSelectManagerModal"
    [scopedTeamId]="team.id.toString()"
    (personSelected)="handleManagerSelected($event)"
    (modalClosed)="handleSelectManagerModalClosed()">
  </app-select-people-modal>
}
</div>

<div class="container-fluid py-4">
  <div class="row mb-4 align-items-center">
    <div class="col-12">
      <h2 class="text-capitalize d-flex align-items-center fw-bold mb-0">
        {{ team.name }}
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary border-0 rounded-circle ms-3 d-flex align-items-center justify-content-center"
          title="{{ 'COMMON.EDIT' | translate }}"
          (click)="editTeam(team)">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </h2>
    </div>
  </div>

  <div class="row mb-4">
  <div class="col-12">
    <div class="card shadow-sm border-0">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-8 border-end pb-3">
            <div class="row">
              <div class="col-md-3 mb-3 ">
                <div><span class="text-muted me-1 fw-bold">Type</span></div>
                <div><span class="badge bg-secondary">{{ team.teamType }}</span></div>
              </div>
              <div class="col-md-4 mb-3">
                <div class="d-flex flex-column">
                  <div class="d-flex align-items-center mb-1">
                    <span class="text-muted me-1 fw-bold">Description</span>
                  </div>
                  <div class="text-break">
                    <span class="text-dark">{{ team.description || 'N/A' }}</span>
                  </div>
                </div>
              </div>
              <div class="col-md-4 mb-3">
                <div class="">
                  <div><span class="text-muted me-1 fw-bold">Manager</span></div>
                  <div class="d-flex align-items-center">
                  @if (team.manager) {
                    <a [routerLink]="['/peoples', team.manager.id]" class="text-decoration-none d-flex align-items-center">
                      <app-avatar [personOrPeople]="team.manager" size="normal" shape="circle" class="me-1"></app-avatar>
                      <span id="managerName" class="text-muted me-2">{{ team.manager.firstName }} {{ team.manager.lastName }}</span>
                    </a>
                    <button type="button" id="changeManager" class="btn btn-link text-decoration-none p-0 me-1" title="{{ 'TEAM.DETAILS.CHANGE_MANAGER' | translate }}" (click)="openSelectManagerModal()">
                      <i class="bi bi-pencil-fill text-muted"></i>
                    </button>
                    <button type="button" id="removeManager" class="btn btn-link text-decoration-none p-0" title="{{ 'TEAM.DETAILS.REMOVE_MANAGER' | translate }}" (click)="removeManager()">
                      <i class="bi bi-x text-muted"></i>
                    </button>
                  } @else {
                    <button type="button" id="selectManager" class="btn btn-link text-decoration-none p-0" title="{{ 'TEAM.DETAILS.SELECT_MANAGER' | translate }}" (click)="openSelectManagerModal()">
                      <i class="bi bi-plus-lg me-1"></i>
                      {{ 'TEAM.DETAILS.SELECT_MANAGER' | translate }}
                    </button>
                  }
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-md-3 small text-muted">
                <span class="mb-1">
                  <div>
                    <i class="bi bi-clock-history me-1"></i>
                    <span class="me-1 fw-bold">{{ 'COMMON.CREATED_AT' | translate }}:</span>
                  </div>
                  <div>
                    <span [attr.title]="team.createdAt | date: 'dd MMM yyyy HH:mm'">
                      {{ team.createdAt | date: 'dd MMM yyyy' }}
                    </span>
                  </div>
                </span>
              </div>
              <div class="col-md-3 small text-muted">
                <span>
                  <div>
                    <i class="bi bi-arrow-clockwise me-1"></i>
                    <span class=" me-1 fw-bold">{{ 'COMMON.UPDATED_AT' | translate }}:</span>
                  </div>
                  <div>
                    <span [attr.title]="team.updatedAt | date: 'dd MMM yyyy HH:mm'">
                      {{ team.updatedAt | date: 'dd MMM yyyy' }}
                    </span>
                  </div>
                </span>
              </div>
            </div>
          </div>
          
          <div class="col-lg-4 d-flex justify-content-center align-items-start py-2">
            <div class="w-100">
              <app-team-score [team]="team" (requestAssignment)="openTeamAssignationModalForNewPerson()" (requestTeamEdit)="editTeam(team)"></app-team-score>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</div>

  <div class="row mb-4">
    <div class="col-12">
      <div class="card shadow-sm border-0">
        <div class="card-header bg-white border-bottom-0 pt-4">
          <h3 class="h5 fw-bold mb-0 d-flex align-items-center">
            <i class="bi bi-robot me-2" style="color: var(--purple-ai-main);"></i>
            AI Insights
          </h3>
        </div>
        <div class="card-body pt-3">
          @if (loadingRecommendations) {
<div class="text-center py-4">
            <div class="d-inline-flex align-items-center gap-2">
              <span>{{ 'TEAM.DETAILS.RECOMMENDATIONS_LOADING' | translate }}</span>
              <div class="spinner-border spinner-border-sm" role="status" aria-label="Chargement...">
                <span class="visually-hidden">{{'COMMON.LOADING'}}</span>
              </div>
            </div>
          </div>
}
          @if (!loadingRecommendations) {
<div>
            @if (recommendations && (recommendations.recommendations.alerts.length || recommendations.recommendations.recommendations.length)) {
              <div class="row">
                <div class="col-md-6">
                  @if (recommendations.recommendations.alerts.length) {
                    <h5 class="fw-bold mb-3 "><i class="bi bi-exclamation-triangle text-warning-custom me-2"></i>Alerts</h5>
                    <div class="accordion" id="alertsAccordion">
                      @for (alert of recommendations.recommendations.alerts; track alert.title; let i = $index) {
                        <div class="accordion-item mb-2 rounded bg-warning-subtle">
                          <h2 class="accordion-header" [id]="'alertHeading' + i">
                            <button class="accordion-button collapsed text-warning-custom py-3" type="button"
                              data-bs-toggle="collapse" [attr.data-bs-target]="'#alertCollapse' + i" aria-expanded="false"
                              [attr.aria-controls]="'alertCollapse' + i">
                              <span class="fw-bold">{{ alert.title }}</span>
                            </button>
                          </h2>
                          <div [id]="'alertCollapse' + i" class="accordion-collapse collapse" [attr.aria-labelledby]="'alertHeading' + i"
                            data-bs-parent="#alertsAccordion">
                            <div class="accordion-body text-warning-custom">
                              {{ alert.description }}
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>

                <div class="col-md-6">
                  @if (recommendations.recommendations.recommendations.length) {
                    <h5 class="fw-bold mb-3 "><i class="bi bi-lightbulb text-purple-ai me-2"></i>Recommendations</h5>
                    <div class="accordion" id="recommendationsListAccordion">
                      @for (reco of recommendations.recommendations.recommendations; track reco.title; let i = $index) {
                        <div class="accordion-item mb-2 rounded bg-purple-ai-subtle">
                          <h2 class="accordion-header" [id]="'recoHeading' + i">
                            <button class="accordion-button collapsed text-purple-ai py-3" type="button"
                              data-bs-toggle="collapse" [attr.data-bs-target]="'#recoCollapse' + i" aria-expanded="false"
                              [attr.aria-controls]="'recoCollapse' + i">
                              <span class="fw-bold">{{ reco.title }}</span>
                            </button>
                          </h2>
                          <div [id]="'recoCollapse' + i" class="accordion-collapse collapse" [attr.aria-labelledby]="'recoHeading' + i"
                            data-bs-parent="#recommendationsListAccordion">
                            <div class="accordion-body text-purple-ai">
                              {{ reco.description }}
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            } @else if (recommendationsLoaded && (!recommendations || (!recommendations.recommendations.alerts.length && !recommendations.recommendations.recommendations.length))) {
              <div class="alert alert-secondary mb-0">
                Aucune alerte ni recommandation pour cette équipe.
              </div>
            }
          </div>
}
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-lg-8 mb-4">
      <div class="card shadow-sm border-0 mb-4">
        <div class="card-header d-flex justify-content-between align-items-center bg-white border-bottom-0 pt-4">
          <h3 class="h5 fw-bold mb-0">{{ 'TEAM.DETAILS.MEMBERS' | translate }} <span class="fw-bold">({{ team.peoples.length }})</span></h3>
          <button id="addPersonToTeam" class="btn btn-link text-decoration-none p-0" type="button"
            (click)="openTeamAssignationModalForNewPerson()" title="{{ 'TEAM.DETAILS.ADD_PERSON_TO_TEAM' | translate }}">
            <i class="bi bi-plus-lg me-1"></i> {{ 'TEAM.DETAILS.ADD_PERSON_TO_TEAM' | translate }}
          </button>
        </div>
        <div class="card-body pt-3 members-table">
          @if (team.peoples.length) {
            <div class="table-responsive">
              <table class="table table-hover table-striped mb-0">
                <thead>
                  <tr>
                    <th scope="col">{{ 'TEAM.DETAILS.NAME' | translate }}</th>
                    <th scope="col">{{ 'TEAM.DETAILS.ROLE' | translate }}</th>
                    <th scope="col">{{ 'COMMON.STATUS' | translate }}</th>
                    <th scope="col">{{ 'TEAM.DETAILS.ALLOCATION_RATE' | translate }}</th>
                    <th scope="col">{{ 'COMMON.ACTIONS' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (person of team.peoples; track person.id) {
                  <tr [ngClass]="getPersonHiringStatusClass(person)">
                    <td scope="row" class="d-flex align-items-center py-2">
                      <app-avatar [personOrPeople]="person" size="normal" shape="circle" class="me-1"></app-avatar>
                      <a [routerLink]="['/peoples', person.id]" class="text-dark text-decoration-none fw-bold">{{ person.firstName }} {{ person.lastName }}</a>
                      @if (getPersonStatusIconAndMessage(person); as statusInfo) {
                        <app-people-status-icon
                            [icon]="statusInfo.icon"
                            [color]="statusInfo.color"
                            [message]="statusInfo.message"
                            [date]="statusInfo.date">
                        </app-people-status-icon>
                      } 
                    </td>
                    <td scope="row" class="py-2">{{ person.role?.name }}</td>
                    <td scope="row" class="py-2">
                        <app-people-status [person]="person"></app-people-status>
                      </td>
                    <td scope="row" class="py-2">
                      <span class="badge bg-light text-black-50">
                        {{ getAllocationRateForCurrentTeam(person)}}%
                        </span>
                    </td>
                    <td scope="row" class="py-2">
                      <button title="{{ 'PEOPLE.ASSIGN' | translate }}"
                        class="btn btn-outline-secondary btn-sm rounded-pill d-flex align-items-center justify-content-center"
                        (click)="openTeamAssignationModal(person)">
                        <i class="bi bi-people-fill"></i>
                      </button>
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <p class="text-muted mb-0">{{ 'TEAM.DETAILS.NO_MEMBERS_ASSIGNED' | translate }}</p>
          }
        </div>
      </div>

      <app-events
        [itemTypeEvents]="'team'"
        [itemId]="teamId">
      </app-events>

      
    </div>

    <div class="col-lg-4 mb-4">
      <div class="card shadow-sm border-0 roles-card">
        <div class="card-header d-flex align-items-center bg-white border-bottom-0 pt-4">
          <h3 class="h5  fw-bold mb-0">{{ 'TEAM.DETAILS.REQUIRED_ROLES' | translate }}</h3>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary border-0 rounded-circle ms-3 d-flex align-items-center justify-content-center"
            title="{{ 'COMMON.EDIT' | translate }}"
            (click)="editTeam(team)">
            <i class="bi bi-pencil-fill"></i>
          </button>
        </div>
        <div class="card-body pt-3">
          @if (team.roles.length) {
          <ul class="list-unstyled">
            @for (teamRoleRequirement of team.roles; track teamRoleRequirement.role.id) {
            <li class="d-flex justify-content-between align-items-center rounded mb-2 px-3 py-2 alert"
                [class]="teamRoleRequirement.coverageStatus === 'default' ? 'alert-light text-dark' : 'alert-' + teamRoleRequirement.coverageStatus">
                <div>
                    <a [routerLink]="['/roles', teamRoleRequirement.role.id]" class="text-decoration-none text-body fw-semibold">
                        {{ teamRoleRequirement.role.name }}
                    </a>
                </div>
                <span class="ms-2 py-2 px-3 text-nowrap">
                    <span class="me-1 fw-semibold">
                        {{ teamRoleRequirement.coverageCount | number:'1.0-2' }} / {{ teamRoleRequirement.required_fte }}
                    </span>
                </span>
            </li>
            }
          </ul>
          } @else {
            <p class="text-muted">{{ 'TEAM.DETAILS.NO_ROLES_ASSIGNED' | translate }}</p>
          }
        </div>
      </div>

      <div class="card shadow-sm border-0 mt-4">
        <div class="card-header bg-white d-flex align-items-center  border-bottom-0 pt-4">
          <h3 class="h5 fw-bold mb-0">{{ 'TEAM.DETAILS.REQUIRED_SKILLS' | translate }}</h3>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary border-0 rounded-circle ms-3 d-flex align-items-center justify-content-center"
            title="{{ 'COMMON.EDIT' | translate }}"
            (click)="editTeam(team)">
            <i class="bi bi-pencil-fill"></i>
          </button>
        </div>
        <div class="card-body pt-3">
          @if (team.skills.length) {
            <div class="d-flex flex-wrap gap-2">
              @for (skill of team.skills; track skill.id) {
                <span class="badge rounded-pill py-2 px-3 alert"
                        [class]="'alert-' + skill.coverageStatus">
                        <a [routerLink]="['/skills', skill.id]" class="text-decoration-none" [class]="'text-' + skill.coverageStatus">
                            {{ skill.name }}
                            @if (skill.coverageCount !== undefined) {
<span> ({{ skill.coverageCount }})</span>
}
                        </a>
                    </span>
              }
            </div>
          } @else {
            <p class="text-muted">{{ 'PEOPLE.DETAILS.NO_SKILLS_ASSIGNED' | translate }}</p>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<div class="offcanvas offcanvas-end" tabindex="-1" id="teamFormContainer" aria-labelledby="teamFormLabel"
    [class.show]="showTeamForm">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="teamFormLabel">
      {{ teamToEdit ? ('TEAM.FORM.EDIT_TEAM' | translate) : ('TEAM.FORM.ADD_TEAM' | translate) }}
    </h5>
    <button type="button" class="btn-close text-reset" aria-label="Close" (click)="hideTeamForm()"></button>
  </div>
  <div class="offcanvas-body">
    @if (showTeamForm) {
      <app-team-form
        [teamToEdit]="teamToEdit"
        (formSubmitted)="handleFormSubmission($event)"
        (cancel)="onCancelForm()">
      </app-team-form>
    }
  </div>
</div>